import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../src/environments/environment';
import { LeaseDTO, CreateLeaseRequest, UpdateLeaseRequest } from '../model/lease.model';

export const LEASES_ADMIN_URL = `${environment.apiBaseAdminUrl}/leases`;

@Injectable({
  providedIn: 'root',
})
export class LeaseService {
  constructor(private http: HttpClient) {}

  getLeases(): Observable<LeaseDTO[]> {
    return this.http.get<LeaseDTO[]>(LEASES_ADMIN_URL);
  }

  createLease(request: CreateLeaseRequest): Observable<LeaseDTO> {
    return this.http.post<LeaseDTO>(LEASES_ADMIN_URL, request);
  }

  updateLease(id: number, request: UpdateLeaseRequest): Observable<LeaseDTO> {
    return this.http.put<LeaseDTO>(`${LEASES_ADMIN_URL}/${id}`, request);
  }

  uploadLeaseFile(id: number, file: File): Observable<void> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<void>(`${LEASES_ADMIN_URL}/${id}/files`, formData);
  }

  uploadLeaseFiles(id: number, files: File[]): Observable<void> {
    const formData = new FormData();
    files.forEach(f => formData.append('files', f));
    return this.http.post<void>(`${LEASES_ADMIN_URL}/${id}/files/batch`, formData);
  }

  updateLeaseFile(id: number, file: File): Observable<void> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.put<void>(`${LEASES_ADMIN_URL}/${id}/files`, formData);
  }

  viewLeaseFile(fileId: number): Observable<Blob> {
    return this.http.get(`${LEASES_ADMIN_URL}/files/${fileId}/view`, { responseType: 'blob' });
  }

  downloadLeaseFile(fileId: number): Observable<Blob> {
    return this.http.get(`${LEASES_ADMIN_URL}/files/${fileId}/download`, { responseType: 'blob' });
  }

  deleteLeaseFile(fileId: number): Observable<void> {
    return this.http.delete<void>(`${LEASES_ADMIN_URL}/files/${fileId}`);
  }
}
